(function(){
var rtRoot = document.querySelector('.rt-customizer');
var rtLocked = !!(rtRoot && rtRoot.getAttribute('data-locked') === 'true');
var rtImg = rtRoot ? (rtRoot.getAttribute('data-img') || '') : '';
function bind(inputId, targetId){
var input = document.getElementById(inputId);
var target = document.getElementById(targetId);
if(!input || !target) return;
input.addEventListener('input', function(){
target.textContent = input.value;
});
}
bind('rt-in-title','rt-ov-title');
bind('rt-in-sub','rt-ov-sub');
bind('rt-in-name','rt-ov-name');
function bindCounter(inputId, countId, max){
var input = document.getElementById(inputId);
var count = document.getElementById(countId);
if(!input || !count) return;
function update(){
var len = input.value.length;
count.textContent = len + '/' + max;
count.classList.toggle('rt-near-limit', len >= max - 3);
}
input.addEventListener('input', update);
update();
}
bindCounter('rt-in-title','rt-count-title',24);
bindCounter('rt-in-sub','rt-count-sub',45);
bindCounter('rt-in-name','rt-count-name',24);
function bindOptional(inputId, valueId, wrapId){
var input = document.getElementById(inputId);
var value = document.getElementById(valueId);
var wrap = document.getElementById(wrapId);
if(!input || !value || !wrap) return;
function update(){
if(input.value === ''){
wrap.style.display = 'none';
} else {
wrap.style.display = '';
value.textContent = input.value;
}
}
input.addEventListener('input', update);
update();
}
bindOptional('rt-in-abv','rt-abv-val','rt-abv-wrap');
bindOptional('rt-in-vol','rt-vol-val','rt-vol-wrap');
var fontSelect = document.getElementById('rt-in-font');
var fontTargets = [
document.getElementById('rt-ov-title'),
document.getElementById('rt-ov-sub'),
document.getElementById('rt-ov-name'),
document.getElementById('rt-abv-wrap'),
document.getElementById('rt-vol-wrap')
];
function applyFontPreview(){
var opt = fontSelect.options[fontSelect.selectedIndex];
var cssFont = opt ? opt.getAttribute('data-css') : 'Arial, sans-serif';
fontTargets.forEach(function(el){
if(el) el.style.fontFamily = cssFont;
});
}
if(fontSelect){
fontSelect.addEventListener('change', applyFontPreview);
applyFontPreview(); // set initial preview font on load
}
var colourSelect = document.getElementById('rt-in-colour');
var swatch = document.getElementById('rt-swatch');
function applyColourPreview(){
var c = colourSelect ? colourSelect.value : '#111111';
fontTargets.forEach(function(el){
if(el) el.style.color = c;
});
if(swatch) swatch.style.background = c;
}
if(colourSelect){
colourSelect.addEventListener('change', applyColourPreview);
applyColourPreview();
}
var fileInput = document.getElementById('rt-in-image');
var img = document.getElementById('rt-img');
var placeholder = document.getElementById('rt-placeholder');
var uploadError = document.getElementById('rt-upload-error');
var uploadRequiredError = document.getElementById('rt-upload-required-error');
var uploadBox = document.getElementById('rt-upload-box');
var MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
var selectedGenericUrl = null;
var galleryFiles = (rtRoot && rtRoot.getAttribute('data-gallery')) ? rtRoot.getAttribute('data-gallery').split(',').filter(Boolean) : ['xmas_1.jpg','XMAS_2.jpg','xmas_3.1.jpg','xmas_4.jpg','xmas_5.jpg','xmas_6.jpg'];
var galleryBase = 'https://cdn.shopify.com/s/files/1/0520/9384/5665/files/';
var galleryEl = document.getElementById('rt-gallery');
if(!rtLocked && galleryEl){
galleryFiles.forEach(function(fn){
var url = galleryBase + fn;
var item = document.createElement('div');
item.className = 'rt-gallery-item';
item.setAttribute('data-url', url);
var im = document.createElement('img');
im.src = url;
item.appendChild(im);
galleryEl.appendChild(item);
});
}
var galleryItems = document.querySelectorAll('.rt-gallery-item');
function clearGallerySelection(){
selectedGenericUrl = null;
galleryItems.forEach(function(el){ el.classList.remove('rt-selected'); });
}
function clearUpload(){
if(fileInput) fileInput.value = '';
}
function showImage(src){
img.src = src;
img.style.display = 'block';
placeholder.style.display = 'none';
uploadRequiredError.style.display = 'none';
uploadBox.classList.remove('rt-required-empty');
}
function clearImage(){
img.src = '';
img.style.display = 'none';
placeholder.style.display = 'block';
}
function applyLockedImage(){
if(rtLocked && rtImg){
selectedGenericUrl = rtImg;
showImage(rtImg);
}
}
if(fileInput){
fileInput.addEventListener('change', function(){
var file = fileInput.files && fileInput.files[0];
if(!file) return;
if(file.size > MAX_FILE_SIZE){
uploadError.style.display = 'block';
fileInput.value = '';
return;
}
uploadError.style.display = 'none';
clearGallerySelection(); // uploading your own photo overrides a gallery pick
var reader = new FileReader();
reader.onload = function(e){
showImage(e.target.result);
};
reader.readAsDataURL(file);
});
}
galleryItems.forEach(function(el){
el.addEventListener('click', function(){
clearUpload(); // picking a gallery image overrides an uploaded photo
clearGallerySelection();
el.classList.add('rt-selected');
selectedGenericUrl = el.getAttribute('data-url');
showImage(selectedGenericUrl);
});
});
applyLockedImage();
var resetBtn = document.getElementById('rt-reset-btn');
if(resetBtn){
resetBtn.addEventListener('click', function(){
['rt-in-title','rt-in-sub','rt-in-name','rt-in-abv','rt-in-vol'].forEach(function(id){
var el = document.getElementById(id);
if(el) el.value = el.defaultValue;
});
if(fontSelect){ fontSelect.selectedIndex = 0; applyFontPreview(); }
if(colourSelect){ colourSelect.selectedIndex = 0; applyColourPreview(); }
clearUpload();
clearGallerySelection();
clearImage();
uploadError.style.display = 'none';
uploadRequiredError.style.display = 'none';
uploadBox.classList.remove('rt-required-empty');
['rt-in-title','rt-in-sub','rt-in-name','rt-in-abv','rt-in-vol'].forEach(function(id){
document.getElementById(id).dispatchEvent(new Event('input'));
});
applyLockedImage();
});
}
var mainForm = document.getElementById('product-form-main')
|| document.querySelector('form[data-type="add-to-cart-form"]');
if(mainForm){
function makeHiddenMirror(name){
var el = document.createElement('input');
el.type = 'hidden';
el.name = 'properties[' + name + ']';
mainForm.appendChild(el);
return el;
}
var mirrorTitle = makeHiddenMirror('Bottle name');
var mirrorSub = makeHiddenMirror('Joke line');
var mirrorName = makeHiddenMirror('Product name');
var mirrorAbv = makeHiddenMirror('ABV %');
var mirrorVol = makeHiddenMirror('Volume (cl)');
var mirrorFont = makeHiddenMirror('Font');
var mirrorColour = makeHiddenMirror('Text colour');
function syncMirrors(){
mirrorTitle.value = document.getElementById('rt-in-title').value;
mirrorSub.value = document.getElementById('rt-in-sub').value;
mirrorName.value = document.getElementById('rt-in-name').value;
mirrorAbv.value = document.getElementById('rt-in-abv').value;
mirrorVol.value = document.getElementById('rt-in-vol').value;
mirrorFont.value = fontSelect ? fontSelect.value : ''; // Placid font CODE, e.g. "ebgaramond-regular"
mirrorColour.value = colourSelect ? colourSelect.value : '#111111';
}
['rt-in-title','rt-in-sub','rt-in-name','rt-in-abv','rt-in-vol'].forEach(function(id){
document.getElementById(id).addEventListener('input', syncMirrors);
});
if(fontSelect) fontSelect.addEventListener('change', syncMirrors);
if(colourSelect) colourSelect.addEventListener('change', syncMirrors);
syncMirrors(); // set initial values immediately
var mirrorFile = document.createElement('input');
mirrorFile.type = 'file';
mirrorFile.style.display = 'none';
mainForm.appendChild(mirrorFile);
var mirrorGenericUrl = document.createElement('input');
mirrorGenericUrl.type = 'hidden';
mainForm.appendChild(mirrorGenericUrl);
mainForm.addEventListener('submit', function(e){
var hasUpload = fileInput && fileInput.files && fileInput.files[0];
var hasGeneric = !!selectedGenericUrl;
if(!hasUpload && !hasGeneric){
e.preventDefault();
e.stopImmediatePropagation();
uploadRequiredError.style.display = 'block';
uploadBox.classList.add('rt-required-empty');
uploadBox.scrollIntoView({behavior: 'smooth', block: 'center'});
return false;
}
syncMirrors();
mirrorFile.name = '';
mirrorGenericUrl.name = '';
if(hasUpload){
mirrorFile.name = 'properties[Uploaded Image]';
try {
var dt = new DataTransfer();
dt.items.add(fileInput.files[0]);
mirrorFile.files = dt.files;
} catch(err) {}
} else if(hasGeneric){
mirrorGenericUrl.name = 'properties[Uploaded Image]';
mirrorGenericUrl.value = selectedGenericUrl;
}
}, true);
}
})();
